import { render } from "./StayCompliant.vue?vue&type=template&id=1af8685c"
import script from "./StayCompliant.vue?vue&type=script&lang=js"
export * from "./StayCompliant.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__